module.exports = __webpack_public_path__ + "img/06.dca72288.jpg";